import { render, staticRenderFns } from "./PcaPlotView.vue?vue&type=template&id=173621e6"
import script from "./PcaPlotView.vue?vue&type=script&lang=js"
export * from "./PcaPlotView.vue?vue&type=script&lang=js"
import style0 from "./PcaPlotView.vue?vue&type=style&index=0&id=173621e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports